import { ProgramEngagementModel, ProgramTask } from '@cibo/core'
import {
  useProgramEngagementConfirmTask,
  useProgramEngagementFields,
  useUpdateProgramEngagement,
} from '@cibo/programs'
import { logRequestError } from '@cibo/ui'
import { useSnackbar } from 'notistack'
import { filter } from 'ramda'

export const useHandleLockDetails = (
  engagement?: ProgramEngagementModel | null,
  task?: ProgramTask,
  navigateToNextTask?: (currentTaskId: string) => void
) => {
  const { enqueueSnackbar } = useSnackbar()
  const fields = useProgramEngagementFields({ id: engagement?.id })
  const lockDetails = useProgramEngagementConfirmTask()
  const updateEngagement = useUpdateProgramEngagement()
  if (!engagement || !task) {
    return () => console.error('attempting to lock details without an engagement or task')
  }
  const taskState = engagement.getTaskStatus(task.id)

  const ineligibleFields = filter(
    ({ resourceId }) =>
      !!taskState?.status.eligibility?.reasonItems?.some(item => item.id === resourceId),
    fields.data?.items ?? []
  )

  const handleLockDetails = async () => {
    if (taskState?.status.progress?.completed) {
      navigateToNextTask && navigateToNextTask(task.id)
    } else {
      if (!!ineligibleFields.length) {
        // if ineligible fields, first remove them from the engagement
        await updateEngagement.mutate({
          action: 'remove',
          id: engagement.id,
          fields: ineligibleFields.map(({ resourceId }) => resourceId),
        })
      }
      // then lock details
      lockDetails
        .mutateAsync(
          { id: engagement.id, taskId: task.id },
          {
            onError: err => {
              logRequestError(err, { engagementId: engagement.id, taskId: task.id })
              enqueueSnackbar(err.response?.data.message, { variant: 'error' })
            },
          }
        )
        .then(() => {
          navigateToNextTask && navigateToNextTask(task.id)
        })
    }
  }

  return handleLockDetails
}
